import { createSelector } from "@ngrx/store";
import { selectDataState } from "../../data.selectors";

// **************************************************************************
// FINANCING COMPANIES SELECTORS
// **************************************************************************
export const selectFinancingCompanyState = createSelector(selectDataState, state => state.financingCompany);
export const selectFinancingCompanies = createSelector(selectFinancingCompanyState, state => state.financingCompanies);
export const selectFinancingCompaniesLoading = createSelector(selectFinancingCompanyState, state => state.financingCompaniesLoading);
export const selectFinancingCompaniesLoaded = createSelector(
    selectFinancingCompanies,
    selectFinancingCompaniesLoading,
    (financingCompanies, loading) => financingCompanies !== null && !loading,
);
